// import React from "react";
import * as React from "react";

import MonthlyPackages from "../packages/monthlyPackages";
import YearlyPackages from "../packages/yearlyPackage";
import LifeTime from "../packages/lifetimePackages";

type TabContentProps = {
  activeTab: string; // Can be "Monthly", "Yearly", or "LifeTime"
};

const TabContent: React.FC<TabContentProps> = ({ activeTab }) => {
  const content: Record<string, JSX.Element> = {
    Monthly: <MonthlyPackages />,
    Yearly: <YearlyPackages />,
    LifeTime: <LifeTime />,
  };

  return content[activeTab] || <div>Tab content not available</div>;
};

export default TabContent;
